import React from 'react';
import { Form, Icon, Input, Button, Radio, message } from 'antd';
import { getPermissions } from '../../api/inspiration';
import "./index.css";

class Index extends React.Component {

    componentDidMount() {
        let permissions = localStorage.getItem('permissions'),
        username = localStorage.getItem('username'),
        password = localStorage.getItem('password'),
        systemType = localStorage.getItem('systemType');
        if (permissions && username && password && systemType) {
            this.props.history.push({
                pathname: `/${systemType}`
            });
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const { systemType, username, password } = values;
                const res = await getPermissions(username + '');
                let permissions = null;
                if (res.error.code == 0 && res.data.length > 0) {
                    permissions = JSON.stringify(res.data[0]);
                    localStorage.setItem('permissions', permissions);
                }
                localStorage.setItem('username', username + '');
                localStorage.setItem('password', password + '');
                if (systemType == 'inspiration') {
                    localStorage.setItem('systemType', 'inspiration');
                    this.props.history.push('/inspiration');
                } else {
                    localStorage.setItem('systemType', 'case');
                    this.props.history.push('/case/hometodayrecommend');
                }

            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div id={"components-form-demo-normal-login"}>

                <Form onSubmit={this.handleSubmit} className="login-form">
                    <div><img src={"https://cdn.code.znzmo.com/img/img_logo2.0.png"} /></div>
                    <Form.Item>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: 'Please input your username!' }],
                        })(
                            <Input
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="账号"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Please input your Password!' }],
                        })(
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="密码"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('systemType', {
                            initialValue: 'case',
                        })(<Radio.Group  >
                            <Radio value={'case'}>案例后台</Radio>
                            <Radio value={'inspiration'}>灵感后台</Radio>
                        </Radio.Group>)}
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            登录
                        </Button>

                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedNormalLoginForm = Form.create({})(Index)

export default WrappedNormalLoginForm